import { MultiSelect, MultiSelectOption } from 'corso-admin-ui';
import { isTruthy } from 'corso-types';
import { Controller } from 'react-hook-form';
import { useProtectionRates } from '../../hooks/useProtectionRates';
import { ShippingRate } from '../../shippingPlus/ShippingRate';
import { useAutomationFormContext } from '../hooks/useAutomationForm';

export default function EventQuoteOrderShipment() {
  const { control } = useAutomationFormContext();

  const { data: protectionRates } = useProtectionRates();

  const protectionRateOptions = protectionRates.map(
    (rate) =>
      ({
        value: `${rate.id}`,
        keywords: [rate.name, rate.description].filter(isTruthy),
        label: <ShippingRate rate={rate} />,
      }) satisfies MultiSelectOption,
  );

  return (
    <Controller
      control={control}
      name="event.params.storeShipRateIds"
      render={({ field, fieldState }) => (
        <MultiSelect
          label="Shipping Rates"
          options={protectionRateOptions}
          details="The rates to offer."
          placeholder="Select Rates"
          value={field.value
            .map((value) =>
              protectionRateOptions.find(
                (option) => option.value === `${value}`,
              ),
            )
            .filter(isTruthy)}
          onChange={(selected) =>
            field.onChange(selected.map(({ value }) => Number(value)))
          }
          error={fieldState.error?.message}
        />
      )}
    />
  );
}
